import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';
import { EnvelopeOpenIcon } from '@heroicons/react/20/solid';
import { findLink } from '../../../../../LinkyLinky';
import { emptyFragment } from '../../../../../EmptyFragment';
import ModalStore from '../../../../Modal/Store';
import { MulticheckStore } from '../../../../../Multicheck/Store';
import { InvitationResource } from '../Store/Types';
import BulkEditInvitationsStore from './EditInvitations/Store';

interface Props {
  store: BulkEditInvitationsStore;
  multicheckStore: MulticheckStore<InvitationResource>;
  modalStore: ModalStore;
}

function DeactivateButton({ store, multicheckStore, modalStore }: Props) {
  const openModal = () => {
    store.confirmingDeactivate(multicheckStore);
    modalStore.open();
  };

  return findLink('deactivate', store.invitationsStore.links)
    .map(() => (
      <>
        <button
          className="flex rounded-md border-[1px] items-center border-solid border-red-700 px-5 py-2 text-red-700"
          onClick={openModal}
        >
          <span className="mr-2">
            <EnvelopeOpenIcon height={'25px'} />
          </span>
          <T kind="Remove Collection Access" />
        </button>
      </>
    ))
    .getOrElse(emptyFragment);
}

export default observer(DeactivateButton);
